import React from 'react';
import { Link } from 'react-router-dom';

import GenreList from 'rebook/apps/catalog/components/GenreList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SearchGenresThemesList = ({ genresList, nichesList, tagsList, genresThemesCount, query }) => (
  <div className={styles.section}>
    <div className="title-1">Жанры и темы</div>
    {genresThemesCount > 4 && (
      <Link
        className="cy-search-all-genres-themes"
        to={{
          pathname: `/search/genres-themes/`,
          state: { genresList, nichesList, tagsList, genresThemesCount, query },
          search: `?q=${query}` }}>
        <div className="link">
          {genresThemesCount} {pluralize(genresThemesCount, 'жанр и тема', 'жанра и темы', 'жанров и тем')}
        </div>
      </Link>
    )}
    <div className={styles.content}>
      <GenreList genres={genresList} niches={nichesList} tags={tagsList} maxElementsView={4} />
    </div>
  </div>
);

export default SearchGenresThemesList;
